// extracted by mini-css-extract-plugin
export default {"header":"Itinerary_header__jluwI","tabs":"Itinerary_tabs__GWpKp","tab":"Itinerary_tab__YteTy"};